function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { StyledDynamicDevlinkComponent } from "./dynamic-devlink-component.scss.js";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
import { DEVLINK_COMPONENT_CONFIGS } from "./constants/devlink-component-types";
import { EXTERNAL_SCRIPT_ID } from "./constants/external-script-constants";
import { initSplide } from "./services/splide/index.js";
import { addScriptToDOM } from "./services/external-script-service";
function DynamicDevlinkComponent({ devlinkComponent }) {
    const rootRef = useRef(null);
    useEffect(()=>{
        addScriptToDOM();
        initSplide(rootRef.current);
        return ()=>{
            const script = document.getElementById(EXTERNAL_SCRIPT_ID);
            if (script) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);
    const renderDevlinkComponent = (devlinkConfig)=>{
        var _DEVLINK_COMPONENT_CONFIGS_devlinkConfig, _DEVLINK_COMPONENT_CONFIGS_devlinkConfig_componentType;
        // Handle both old format (string) and new format (object)
        const Component = typeof devlinkConfig === "string" ? (_DEVLINK_COMPONENT_CONFIGS_devlinkConfig = DEVLINK_COMPONENT_CONFIGS[devlinkConfig]) === null || _DEVLINK_COMPONENT_CONFIGS_devlinkConfig === void 0 ? void 0 : _DEVLINK_COMPONENT_CONFIGS_devlinkConfig.component : (_DEVLINK_COMPONENT_CONFIGS_devlinkConfig_componentType = DEVLINK_COMPONENT_CONFIGS[devlinkConfig === null || devlinkConfig === void 0 ? void 0 : devlinkConfig.componentType]) === null || _DEVLINK_COMPONENT_CONFIGS_devlinkConfig_componentType === void 0 ? void 0 : _DEVLINK_COMPONENT_CONFIGS_devlinkConfig_componentType.component;
        if (!Component) {
            return null;
        }
        const _ref = devlinkComponent || {}, { componentType } = _ref, componentProps = _object_without_properties(_ref, [
            "componentType"
        ]);
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, componentProps));
    };
    return /*#__PURE__*/ _jsx(StyledDynamicDevlinkComponent, {
        ref: rootRef,
        className: "dynamic-devlink-component",
        children: renderDevlinkComponent(devlinkComponent)
    });
}
DynamicDevlinkComponent.defaultProps = DefaultProps;
export default withGenericConfig(DynamicDevlinkComponent);
